module.exports = {
  flockerHover (index, image, done) {
    // var profile = document.getElementById('profile')
    var profileImage = document.getElementById('previewImage')
    // profile.setAttribute('flock', index)
    // profileImage.setAttribute('flock', index)
    // profileImage.setAttribute('style', 'background-image: url(' + image + ');')

    window.Velocity(profileImage, { right: 0 }, { duration: 900, complete: done })
  },
  removeImage () {
    // console.log('we are here')
    var images = document.getElementsByClassName('item')
    for (var a = 0; a < images.length; a++) {
      if (images[a].classList.contains('showing')) {

      } else {
        var showingImage = images[a]
        showingImage.style.opacity = 0
        // showingImage.style.zIndex = 0
      }
    }
  },
  addImage (person) {
    var hoverPerson = person
    var images = document.getElementsByClassName('item')
    for (var a = 0; a < images.length; a++) {
      var imageName = images[a].getAttribute('name-attr')
      // console.log('name....' + imageName)
      if (imageName === hoverPerson) {
        // console.log('yay')
        images[a].classList.add('showing')
        window.Velocity(images[a], { left: '-49vw' }, {
          duration: 500,
          easing: [ 0.42, 0, 1, 1 ],
          complete: function () {
            // console.log('finished')
          }
        })
      }
    }
  },
  nameHover (name, done) {
    // console.log('.....adding hover.')
    var windowWidth = window.outerWidth
    if (windowWidth >= 1024) {
      var hoverPerson = name
      // var vm = this
      // vm.addImage(hoverPerson)

      var images = document.getElementsByClassName('item')
      for (var a = 0; a < images.length; a++) {
        if (images[a].classList.contains('velocity-animating')) {
          window.Velocity(images[a], 'stop')
          images[a].style.left = '0'
          // console.log(hoverPerson)
          var imageName = images[a].getAttribute('name-attr')
          if (imageName === hoverPerson) {
            images[a].classList.add('showing')
            // images[a].style.opacity = '1'
            images[a].style.zIndex = '1'
            window.Velocity(images[a], { left: '-49vw' }, {
              duration: 200,
              easing: [ 0.42, 0, 1, 1 ],
              complete: function () {
                // console.log('finished')
              }
            })
          }
        } else {
          imageName = images[a].getAttribute('name-attr')
          if (imageName === hoverPerson) {
            images[a].classList.add('showing')
            // images[a].style.opacity = '1'
            images[a].style.zIndex = '1'
            window.Velocity(images[a], { left: '-49vw' }, {
              duration: 200,
              easing: [ 0.42, 0, 1, 1 ],
              complete: function () {
                // console.log('finished this one')
              }
            })
          }
        }
      }
    }
  },
  nameRemoveHover () {
    // console.log('HOVER GONE.....')
    // var showingImage = document.getElementsByClassName('showing')
    // showingImage[0].style.zIndex = 0
    /* window.Velocity(showingImage[0], { left: '0px' }, { duration: 800,
      delay: 200,
      complete: function () {
        showingImage[0].style.opacity = 0
        showingImage[0].classList.remove('showing')
      }
    }) */

    var images = document.getElementsByClassName('item')
    for (var b = 0; b < images.length; b++) {
      if (images[b].classList.contains('showing')) {
        // var vm = this
        images[b].classList.remove('showing')
        images[b].style.zIndex = '-1'
        window.Velocity(images[b], { left: 0 }, {
          duration: 500,
          delay: 50,
          easing: [ 0.42, 0, 1, 1 ],
          complete: function () {
            // vm.removeImage()
          }
        })
      }
    }

    /* var windowWidth = window.outerWidth
    if (windowWidth >= 1024) {
      var vm = this
      var imageContainer = document.getElementById('previewImages')
      var profile = document.getElementsByClassName('Profile')
      profile = profile[0]
      if (!profile) {
        window.Velocity(imageContainer, 'stop', true)
      }
      window.Velocity(imageContainer, { left: '0' }, { duration: 800,
        complete: function () {
          vm.removeImage()
        }
      })
    } */
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/flockers.js